
  import {Component, Vue} from "vue-property-decorator";
  import breadcrumb from "@/components/common/breadcrumb.vue";
  import upload from "@/components/upload/src/index.vue";
  import {createAd, getConfig, getAccountList, getPageList} from '@/services/api';
  import {AdCreateInfo} from "@/model/AdCreateInfo";
  import store from "@/store";
  import draggable from "vuedraggable";
  import validator from "@/services/validatorNew";

  @Component({
    components: {
      'zf-breadcrumb': breadcrumb,
      'zf-upload': upload,
      draggable
    },
  })
  export default class AdCreate extends Vue{
    // 投放成功与否
    public createSuccess = false;
    //面包屑导航
    public navList: {name: String, to?: String}[] = [];
    // 广告信息
    public adCreateInfo: AdCreateInfo = {};
    // 地区列表
    public countryList: {code: string, name: string}[] = [];
    // 账号列表
    public accountList: {code: string, desc: string, available: boolean}[] = [];
    // 主页列表
    public pageList: {code: string, desc: string}[] = [];
    // 最小年龄列表
    public minAgeList: string[] = ["20","22","25","30","35","40","45","50","55","60"];
    // 最大年龄列表
    public maxAgeList: string[] = ["65+","60","55","50","45","40","35","30","25","22"];
    // 性别列表
    public genderList: {code: number, desc: string}[] = [
      {
        code: 0,
        desc: '性别不限'
      },
      {
        code: 1,
        desc: '男性'
      },
      {
        code: 2,
        desc: '女性'
      }
    ]
    // 封面图回显列表
    public coverShowList: {url: string, name: string}[] = [];
    // 封面图上传列表
    public coverList: {url: string, name: string}[] = [];
    // 详情图回显列表
    public detailShowList: {url: string, name: string}[] = [];
    // 详情图上传列表
    public detailList: {url: string, name: string}[] = [];
    // 视频回显列表
    public videoShowList: {url: string, name: string}[] = [];
    // 视频上传列表
    public videoList: {url: string, name: string}[] = [];
    // 详情图拖拽排序控制
    public detailDraggable = false;
    // 大图展示控制
    public dialogVisible = false;
    // 大图展示路径
    public dialogImageUrl = '';
    // 上传图片地址
    public uploadUrl = (process.env.VUE_APP_BASE_API.length == 0 ? (location.origin + "/") : process.env.VUE_APP_BASE_API) + 'api/facebookDeliver/ad/uploadFile';


    // 验证规则
    private rules: {[key: string]:{required: boolean, requiredMsg?: string, reg?: RegExp, regMsg?: string, max?: number, maxMsg?: string, min?: number, minMsg?: string}}= {
      accountId: {required: true, requiredMsg: '请选择创建广告的账号'},
      pageId: {required: true, requiredMsg: '选择投放广告的主页ID'},
      campaignTitlePost: {required: true, requiredMsg: '广告系列（Campaign）标题'},
      adSetTitle: {required: true, requiredMsg: '请填写广告组（Ad Set）标题'},
      gender: {required: true, requiredMsg: '请选择性别'},
      minAge: {required: true, requiredMsg: '请选择最小年龄'},
      maxAge: {required: true, requiredMsg: '请选择最大年龄'},
      budget: {required: true, requiredMsg: '填写单日广告预算上限'},
      title: {required: true, requiredMsg: '请填写广告标题'},
      message: {required: true, requiredMsg: '请填写广告正文'},
      landingPageUrl: {required: true, requiredMsg: '请填写落地页链接'},
      assetImage: {required: true, requiredMsg: '请上传广告封面图'},
    }
      async created(): Promise<void> {
      this.adCreateInfo.itemId = Number(this.$route.params.itemId);
      if (this.adCreateInfo.itemId) {
        // this.navList = [
        //   {name: '站点列表', to: '/stattion/list'},
        //   {name: this.adCreateInfo.itemId.toString()}
        // ]
        const pixelId = Array.isArray(this.$route.query.pixelId)
          ? this.$route.query.pixelId[this.$route.query.pixelId.length -1] || ''
          : this.$route.query.pixelId || '';
        const landingPageUrl = Array.isArray(this.$route.query.landingPageUrl)
          ? this.$route.query.landingPageUrl[this.$route.query.landingPageUrl.length -1] || ''
          : decodeURIComponent(this.$route.query.landingPageUrl) || '';
        const area = Array.isArray(this.$route.query.area)
          ? this.$route.query.area[this.$route.query.area.length -1] || ''
          : decodeURIComponent(this.$route.query.area) || '';
        this.adCreateInfo = {
          itemId: this.adCreateInfo.itemId,
          pixelId,
          landingPageUrl,
          area
        }
        this.adCreateInfo.campaignTitlePre = `${this.adCreateInfo.itemId}_${JSON.parse(localStorage.getItem("userData")||'{}').id}_`;
      }
      await this.getAccountList();
      this.getConfig();
    }

    /**
     * 获取字典信息
     */
    getConfig(): void {
      if (!this.$store.state.region || this.$store.state.region.length === 0) {
        getConfig({type: 'region'}).then(res => {
          if (res.data && res.data.status === 'OK') {
            this.countryList = res.data.result || [];
            store.commit('SET_REGION', this.countryList);
          }
        })
      }
    }

    /**
     * 获取item信息
     */
    async getAccountList(): Promise<void> {
      if (this.adCreateInfo.itemId) {
        await getAccountList({pixelId: this.adCreateInfo.pixelId || ''}, true).then(res => {
          if (res.data && res.data.code === 200) {
            this.accountList = res.data.data;
          }
        });
      }
    }

    accountChange(): void {
      getPageList({accountId: this.adCreateInfo.accountId || ''}, false).then(res => {
        if (res.data && res.data.code === 200) {
          this.pageList = res.data.data;
        }
      });
    }

    /**
     * 保存表单
     */
    async onSubmit(): Promise<void> {
      if(this.createSuccess) {
        try{
          await this.$confirm(`已经投放成功，需要再投放一次吗？`);
        } catch (e) {
          return;
        }
      }
      this.adCreateInfo.assetImage = this.coverList[0]?.url;
      this.adCreateInfo.assetVideo = this.videoList[0]?.url;
      this.adCreateInfo.images = this.detailList.map(item => item.url);
      this.adCreateInfo.campaignTitle = (this.adCreateInfo.campaignTitlePre || '') + (this.adCreateInfo.campaignTitlePost || '');
      if (!this.checkForm()) {
        return;
      }
      if(!this.createSuccess) {
        try{
          await this.$confirm(`确定保存并投放吗？`);
        } catch (e) {
          return;
        }
      }
      this.createAd();
    }

    /**
     * 校验表单内容是否通过
     */
    checkForm(): boolean {
      const adCreateInfo:{[prop:string]: any} = this.adCreateInfo;
      if (this.adCreateInfo.bidCamp) {
        this.rules["bidAmount"] = {required: true, requiredMsg: '填写bid cap值'};
      }
      for (let key of Object.keys(this.rules)) {
        if(!validator(this.rules[key], adCreateInfo[key], (msg: string) => {
          this.$message.error(msg);
          setTimeout(() => {
            const element: any = this.$refs[key];
            element.focus();
          }, 0)
        })) {
          return false;
        }
      }
      return true;
    }

    /**
     * 创建广告
     */
    createAd(): void {
      store.commit('SET_LOADING_MESSAGE', '投放中，请不要关闭或跳转页面');
      store.commit('SET_HARD_LOADING', true);
      createAd(this.adCreateInfo).then(res =>{
        store.commit('SET_LOADING_MESSAGE', '');
        store.commit('SET_HARD_LOADING', false);
        if (res.data && res.data.code === 200){
          this.createSuccess = true;
          this.$message({
            duration: 8000,
            showClose: true,
            message: res.data.message || '投放成功！',
            type: 'success'
          });
        } else {
          this.$message({
            duration: 8000,
            showClose: true,
            message: res.data.message || '投放失败，请检查网络后重试！',
            type: 'warning'
          });
        }
      }).catch(() => {
        store.commit('SET_LOADING_MESSAGE', '');
      });
    };

    /**
     * 取消方法
     */
    cancel() {
      this.$router.push('/');
    }

    /**
     * 检查预算为正整数
     */
    checkBudget(budget: string) {
      this.adCreateInfo.budget = parseInt(budget.replace(/[^0-9\.]+/g,'')).toString();
    }

    /**
     * 检查bid
     */
    checkbidAmount(bidAmount: string) {
      this.adCreateInfo.bidAmount = !bidAmount? '' : parseFloat(bidAmount.replace(/[^0-9\.]+/g,'')).toFixed(2).toString();
    }

    /**
     * 详情图拖拽排序
     */
    detailSort(): void {
      if (this.detailDraggable) {
        const uploadList = this.detailShowList.filter((item: any) => item.status === 'uploading')
        this.detailShowList = [...this.detailList, ...uploadList];
      }
      this.detailDraggable = !this.detailDraggable;
    }


    /**
     * 图片上传失败钩子函数
     */
    handleError(e: any): void {
      this.$message.warning('图片上传失败！');
      if(e.status === 401) {
        // 如果返回401 即没有权限，跳到登录页重新登录
        this.$alert('登录失效，请重新登录')
        this.$router.replace({
          path: '/login',
          query: {redirect: this.$router.currentRoute.fullPath}
        })
      }
    }

    /**
     * 图片展示
     */
    handlePictureCardPreview(file: {name: string, url: string}): void {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }

    /**
     * 图片删除前确认钩子函数
     */
    beforeRemove(): any {
      return this.$confirm(`确定移除该图片吗？`);
    }

    /**
     * 封面图删除钩子函数
     */
    handleRemove1(file: {name: string, url: string}, list: any): void {
      this.coverList = [...list];
      this.coverShowList = [...list];
    }

    /**
     * 封面图上传成功钩子函数
     */
    handleSuccess1(res: any,file: any): void {
      if (res && res['data'][0]) {
        file.url = res['data'][0];
        this.coverList.push(file);
      }
      this.$forceUpdate();
    }

    handleExceed1() {
      this.$message.warning(`封面图最多上传一张图片`);
    }

    /**
     * 详情图删除钩子函数
     */
    handleRemove2(file: {name: string, url: string}, list: any): void {
      this.detailList = [...list];
      this.detailShowList = [...list];
    }

    /**
     * 详情图上传成功钩子函数
     */
    handleSuccess2(res: any,file: any, fileList: any): void {
      if (res && res['data'][0]) {
        file.url = res['data'][0];
        // 图片根据上传顺序重新排序
        let front;
        for (let [index, item] of fileList.entries()) {
          if(item.status !== 'success' && !front) {
            front = index;
          }
          if (item.uid === file.uid && front) {
            fileList.splice(front,1,...fileList.splice(index, 1 , fileList[front]))
            break;
          }
          this.detailShowList = fileList;
        }
        this.detailList.push(file);
      }
    }

    /**
     * 视频删除钩子函数
     */
    handleRemove3(file: {name: string, url: string}, list: any): void {
      this.videoList = [...list];
      this.videoShowList = [...list];
    }

    /**
     * 视频上传成功钩子函数
     */
    handleSuccess3(res: any,file: any): void {
      if (res && res['data'][0]) {
        file.url = res['data'][0];
        this.videoList.push(file);
      }
      this.$forceUpdate();
    }

    handleExceed3() {
      this.$message.warning(`最多上传一个视频`);
    }

    campaignChange(e: any) {
    }

    close() {
      window.close();
    }
  }
